import { makeStyles, tokens } from '@fluentui/react-components';
export var useOfficeUserThemeStyles = makeStyles({
    foreground: {
        color: tokens.colorBrandForeground1,
    },
});
export var OfficeUserThemeSpinner = {
    strokeWidthThicker: '1.5px',
    colorNeutralForeground1: tokens.colorBrandForeground1,
};
//# sourceMappingURL=styles.js.map